export default "__VITE_ASSET__COV0IDJE__"